/*
* Thème: STACK
*/

window.HeaderSearch_PluginInit = function() {
	$('.js-search').click(function() {
		if ($('body').hasClass('--menu-open') && !$.mlmi.mobile.isMobile) {
			$('.burger').click()
		}
		$('body').toggleClass('--search-open')
		$('footer + .search-form__container .search-form__input').focus().select()
		if ($('body').hasClass('--search-open')) {
			$('.search-form__container button, .search-form__container input').attr('tabindex', '2')
		} else {
			$('.search-form__container button, .search-form__container input').attr('tabindex', '-1')
		}
		return false;
	})

	$('.search-form__toggle').click(function() {
		$('body').removeClass('--search-open')
		return false;
	})

	// $.mlmi.mobile.add(function() {
	// 	$('.header__search.mobile-only').append($('footer + .search-form__container').detach())
	// }, function() {
	// 	$('.footer').after($('header .search-form__container').detach())
	// })

	$('body').click(function(e) {
		if ($(e.target).closest('.search-form__container').length == 0 && $(e.target).closest('.search-form__toggle').length == 0) {
			$('body').removeClass('--search-open')
		}
	});
}

/* End: STACK */
